import React from 'react';
import { VStack } from '@adc/parallax-component-library';
function ContentContainer({ children }) {
    return (React.createElement(VStack, { padding: "$4", paddingTop: "$2", gap: "$4" }, children));
}
export { ContentContainer };
